var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFoodWaste = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Recycling-Hand-Trash-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Recycling Hand Trash 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12H0.75a0.75 0.75 0 0 0 0 1.5h0.88a0.5 0.5 0 0 1 0.5 0.46l0.79 8.68A1.49 1.49 0 0 0 4.41 24h6.18a1.49 1.49 0 0 0 1.49 -1.36l0.79 -8.64a0.5 0.5 0 0 1 0.5 -0.46h0.88a0.75 0.75 0 0 0 0 -1.5ZM5.5 20.5a0.5 0.5 0 0 1 -1 0v-5a0.5 0.5 0 0 1 1 0Zm2.5 0a0.5 0.5 0 0 1 -1 0v-5a0.5 0.5 0 0 1 1 0Zm2.5 0a0.5 0.5 0 0 1 -1 0v-5a0.5 0.5 0 0 1 1 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 0a1 1 0 0 0 -1 1 0.42 0.42 0 0 1 -0.52 0.41L16 0.07a4.54 4.54 0 0 0 -2.55 0.29l-8.9 3.82a1 1 0 0 0 -0.55 0.63 1 1 0 0 0 0.13 0.84A3.43 3.43 0 0 0 8 7l5.48 -1.87A3.62 3.62 0 0 1 15.16 5a0.27 0.27 0 0 1 0.21 0.2 0.24 0.24 0 0 1 -0.12 0.26l-3 1.79a2 2 0 0 0 2.06 3.43l3 -1.79a3.47 3.47 0 0 1 1.8 -0.5h2.39a0.5 0.5 0 0 1 0.5 0.5v0.6a1 1 0 0 0 2 0V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFoodWaste);
export default ForwardRef;